// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddPatientModal_modal__3n9JM","saveBtnWrapper":"AddPatientModal_saveBtnWrapper__1yMfS"};